import { useCallback } from 'react'
import { useWebShare } from './useWebShare'

export const useWebShareAuto = (shareUrl?: string) => {
  const { canShare, share: shareRaw } = useWebShare()
  const share = useCallback(() => {
    const url = shareUrl || document.location.href
    const title = document.querySelector('title')?.text
    const text = ''
    // const metaDescription = document.querySelector(
    //   'meta[property="og:description"]'
    // ) as any
    // const text = metaDescription?.content || ''
    console.info('Sharing:', { url, text, title })
    if (!shareRaw) return () => {}
    return shareRaw({ url, text, title: title ?? '' })
  }, [shareRaw, shareUrl])
  return { canShare, share }
}
